import { useEffect } from 'react';
import { navigate } from '@reach/router';

const useAutomaticDownload = (url: string | undefined) => {
  useEffect(() => {
    if (url) {
      navigate(url);
    }
  }, [url]);
};

export default useAutomaticDownload;
